import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import { formatAmount } from '../../../../../../../../common/formatAmount';
import Text from '../../../../../../../../components/_core/Text';

interface TaxRowProps {
  description: string;
  amount?: number | null;
  isTextGrey?: boolean;
  isAmountGrey?: boolean;
  isAmountStrikeThrough?: boolean;
}
const TaxRow: FC<TaxRowProps> = ({
  amount,
  description,
  isAmountGrey,
  isAmountStrikeThrough,
  isTextGrey,
}) => {
  if (amount === null || amount === undefined) {
    return null;
  }

  return (
    <HStack justifyContent="space-between" w="full">
      <Text variant={isTextGrey ? 'light' : 'primary'}>{description}</Text>
      <Text
        fontWeight="weight-500"
        textDecoration={isAmountStrikeThrough ? 'line-through' : undefined}
        variant={isAmountGrey ? 'light' : 'primary'}
      >
        {formatAmount({ forcePlusSign: false, value: amount })}
      </Text>
    </HStack>
  );
};

export default TaxRow;
